import type { ProviderId } from './checkpoint';

export const KEYSYSTEM_PROVIDERS = ['linkvertise', 'lootlabs', 'workink', 'custom'] as const;

export type KeysystemProviderId = (typeof KEYSYSTEM_PROVIDERS)[number];

export const KEYSYSTEM_STATUSES = ['active', 'paused'] as const;

export type KeysystemStatus = (typeof KEYSYSTEM_STATUSES)[number];

export const KEYSYSTEM_LIMITS = {
  maxProviders: KEYSYSTEM_PROVIDERS.length,
  maxDisplayNameLength: 80,
  maxFlowNameLength: 80,
  maxUrlLength: 2_048,
  minSecretLength: 16,
  maxSecretLength: 128,
  minTtlSeconds: 300,
  maxTtlSeconds: 86_400,
  maxPublisherIdLength: 24,
  maxMinimumCompletionSeconds: 70,
} as const;

export const KEYSYSTEM_DEFAULT_TTL_SECONDS = 3_600;

export const KEYSYSTEM_DEFAULT_FLOW_NAME = 'Key system';

export interface KeysystemFlow {
  id: string | null;
  name: string;
  status: KeysystemStatus;
  session_ttl_seconds: number;
}

export interface KeysystemProvider {
  provider: KeysystemProviderId;
  connection_id: string;
  enabled: boolean;
  display_name: string;
  target_url: string;
  publisher_id: string;
  minimum_completion_seconds: number;
  anti_bypass_token_set: boolean;
  callback_secret_set: boolean;
  callback_url: string;
}

export interface KeysystemConfig {
  flow: KeysystemFlow;
  providers: KeysystemProvider[];
}

export interface KeysystemConnectionInput {
  provider: KeysystemProviderId;
  enabled: boolean;
  display_name: string;
  target_url: string;
  publisher_id?: string;
  minimum_completion_seconds?: number;
  anti_bypass_token?: string | null;
  callback_secret?: string | null;
}

export interface SaveKeysystemInput {
  flow: Omit<KeysystemFlow, 'id'>;
  connections: KeysystemConnectionInput[];
}

export interface KeysystemConfigResponse {
  config: KeysystemConfig;
}

export function isKeysystemProvider(value: string): value is KeysystemProviderId {
  return (KEYSYSTEM_PROVIDERS as readonly string[]).includes(value);
}

export function keysystemNeedsToken(provider: ProviderId): boolean {
  return provider === 'linkvertise';
}

export function keysystemNeedsSecret(provider: ProviderId): boolean {
  return provider === 'lootlabs' || provider === 'custom';
}
